import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { set } from 'date-fns';
import {
    IQueryContextChange,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    QueryContextChange,
    QueryContextService,
} from 'src/app/services/query-context/query-context.service';

export interface ICheckboxSettingDashboardItem {
    options: {
        id: QueryContextSettingID;
        viewtype: 'checkbox';
        displayName: string;
        /** Current value */
        value?: any;
        /** Possible values */
        selectOptions?: any;
    };
}

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {
    @Input()
    option!: ICheckboxSettingDashboardItem['options'];
    /** Greys the checkbox out and blocks changes; the current value is kept. */
    @Input()
    disabled = false;
    @Output()
    change = new EventEmitter<IQueryContextChange>();
    checked: boolean = false;

    constructor(
        private queryContextService: QueryContextService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        if (this.option.value) {
            this.checked = true;
        }
        this.queryContextService.appliedQueryContextEmitter.subscribe(
            this.queryContextSubscriber
        );
    }

    onChange(value: boolean) {
        console.log({
            msg: 'CheckboxComponent.onChange',
            id: this.option.id,
            checked: value,
        });
        this.checked = value;
        this.queryContextService.changePendingQueryContext({
            setting: { id: this.option.id, value: value },
        });
    }

    queryContextSubscriber = (contextChange: QueryContextChange) => {
        if (contextChange.reason === 'InitialContext') {
            // if option id in contextChange.context.settings
            // then set value from contextChange.context.settings
            const setting =
                contextChange.context.settings[this.option.id] ?? false;
            // if not boolean then throw error
            if (typeof setting !== 'boolean') {
                throw new Error(
                    `Setting ${this.option.id} must be boolean type`
                );
            }

            if (setting !== this.checked) {
                this.checked = setting;
                this.cd.detectChanges();
            }
        }
    };
}
